module.exports = function findConfigFromBundle(bundle, configs) {
	const configsArray = Object.values(configs);
	const config = configsArray.find((c) => {
		const config_bundle = c.type.split("--")[1];
		return config_bundle === bundle;
	});
	return config;
};
